import {SALPrinterActions} from "../actions/SALPrinterActions";
import {getSALFormat} from "../network/SALPrinterNetworkAPI";
import {StringConstant} from "../../utils/StringConstant";
import {ResponseStatus} from "../../utils/ResponseStatus";
import {callNative, NativeActions, NativeCommands} from "../../utils/NativeBridge";

export const SALPrinterReducer = (state, action) => {
    switch (action.type) {
        case SALPrinterActions.CHANGE_PRINTER:
            callNative(NativeActions.PRINT, NativeCommands.CHANGE_PRINTER, {
                "printer_type": "avery",
                "printer_id": action.data,
                "module_type": "induct"
            });
            return {...state, printerSerial: action.data};

        case SALPrinterActions.CHANGE_PRINTER_SUCCESS:
            return {...state, printerChangeSuccess: true};

        case SALPrinterActions.CHANGE_PRINTER_SUCCESS_RESET:
            return {...state, printerChangeSuccess: false};

        case SALPrinterActions.GET_SAL_FORMAT:
            const {dispatcher} = action.data;
            getSALFormat(dispatcher, StringConstant.AVERY_PRINTER);
            return state;

        case SALPrinterActions.GET_SAL_FORMAT_RESPONSE:
            return {
                ...state,
                isPrintingEnabled: true,
                salFormat: action.printerFormat,
                salFormatResponseStatus: action.responseCode
            };

        case SALPrinterActions.GET_SAL_FORMAT_RESPONSE_ERROR:
            return {
                ...state,
                isLoading: false,
                salFormatResponseStatus: action.responseCode
            };

        case SALPrinterActions.LOADING:
            return {...state, salFormatResponseStatus: ResponseStatus.LOADING};

        case SALPrinterActions.RESET_RESPONSE:
            return {...state, salFormatResponseStatus: null};

        case SALPrinterActions.INDUCT_WITHOUT_PRINTER:
            return {...state, salFormatResponseStatus: null, salFormat: null, isPrintingEnabled: false};

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/components/scanPrinter/reducers/SALPrinterReducer.js